// frontend/shared/src/download.ts —— TD-821：导出 CSV 落盘与行数统计
const BOM = '﻿';

// 去 BOM、去空行后减表头一行
export function csvRowCount(text: string): number {
  const body = text.startsWith(BOM) ? text.slice(BOM.length) : text;
  const lines = body.split(/\r?\n/).filter((l) => l.trim() !== '');
  return Math.max(0, lines.length - 1);
}

// object URL 在 click 之后的下一轮事件循环释放，避免部分浏览器下载被提前中断
export function saveBlob(blob: Blob, filename: string): void {
  if (typeof document === 'undefined') throw new Error('saveBlob 仅在浏览器环境可用');
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}

// 响应未带 Content-Disposition 文件名时的兜底命名
export function fallbackCsvName(prefix: 'goodpayu' | 'goodpayu-agent', page: string, today: string): string {
  return `${prefix}-${page}-${today}.csv`;
}
